// extracted by mini-css-extract-plugin
module.exports = {"message":"errorBoundary_message__3aOBN"};